module.exports = __webpack_public_path__ + "static/media/006.cf232255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/006.jpg
// module id = 303
// module chunks = 0